function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_149740",
  "data-name": "Rectangle 149740",
  width: 58,
  height: 27,
  transform: "translate(736 758)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_313",
  "data-name": "Mask Group 313",
  transform: "translate(-736 -758)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_69615",
  "data-name": "Group 69615",
  transform: "translate(-10.321 -12)"
}, /*#__PURE__*/React.createElement("g", {
  id: "percentage1",
  transform: "translate(746.771 783.265) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M8.5.287l8.851.55a5.264,5.264,0,0,1,3.286,1.608L46.944,28.756c1.256,1.256,1.537,3.019.627,3.929L32.6,47.653a2.058,2.058,0,0,1-1.835.5,3.9,3.9,0,0,1-2.094-1.127L2.363,20.716A5.267,5.267,0,0,1,.754,17.43L-.063,3.563a12.462,12.462,0,0,1,2.72-1.756c1.889-1.03.2-.456,1.683-.588C4.522,1.093,8.5.287,8.5.287ZM-.084,3.942C-.264,1.043.961-.182,2.76-.07L8.5.287Z",
  transform: "translate(0 0)",
  fill: "#e61236"
})), /*#__PURE__*/React.createElement("text", {
  id: "_-10_",
  "data-name": "-10%",
  transform: "translate(760 787.015)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5,
  fontSize: 14,
  fontFamily: "DIN-Medium, DIN",
  fontWeight: 500,
  letterSpacing: "0.02em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "-10%"))));

var SvgBedges2 = function SvgBedges2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 27,
    viewBox: "0 0 58 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBedges2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bedges2.12efac25.svg";
export { ForwardRef as ReactComponent };